import { classNames } from '@movingimage-evp/mi-ui-component-library';
import { useLocation } from 'react-router';
import { State } from 'src/generated/graphql-viewer';

import { useAbsoluteRoutes } from '../../routes';

import styles from '../dev-tools.module.css';

type Props = {
  value?: State;
  onChange: (value?: State) => void;
};

export function MockedEventState({ value, onChange }: Props) {
  const { pathname } = useLocation();
  const { viewer } = useAbsoluteRoutes();

  if (!pathname.startsWith(viewer)) return null;

  return (
    <div className={styles.moduleWrapper}>
      <span>Event state</span>

      {Object.values(State).map((view) => (
        <button
          key={view}
          className={classNames(value === view && styles.active)}
          onClick={() => onChange(value === view ? undefined : view)}
        >
          {view}
        </button>
      ))}
    </div>
  );
}
